import { render, staticRenderFns } from "./BadgedAvatar.vue?vue&type=template&id=91d8fc44"
import script from "./BadgedAvatar.vue?vue&type=script&lang=js"
export * from "./BadgedAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports